export const deserialize = <T extends object>(search: string) => {
  const result = {} as T
  const params = search.slice(1).split("&")
  params.forEach((param) => {
    const [key, value] = param.split("=") as [keyof T, string]
    ;(result as any)[key] = value
  })
  return result
}
